export const QUOTE_STATUS = {
    APPLICATION: "Application",
    QUOTED: "Quoted",
    UNDERWRITER: "Underwriter",
    DECLINED: "Declined",
    APPROVED: "Approved",
    NOTCLEARED: "NotCleared",
}